// @flow

import React from 'react';
import Loading, {LoadingHolder, Types} from '@pb/kit-component-loading';
import type {StatelessFunctionalComponent as FC} from 'react';

type Props = {|
    loading: boolean,
|};

export const CellLoading: FC<Props> = ({loading}: Props) => {
    if (!loading) {
        return null;
    }

    return (
        <div className="data-table__cell-loading">
            <LoadingHolder>
                <Loading type={Types.ICON}/>
            </LoadingHolder>
        </div>
    );
};
